"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityMatchDto = instanceOfOrientationOpportunityMatchDto;
exports.OrientationOpportunityMatchDtoFromJSON = OrientationOpportunityMatchDtoFromJSON;
exports.OrientationOpportunityMatchDtoFromJSONTyped = OrientationOpportunityMatchDtoFromJSONTyped;
exports.OrientationOpportunityMatchDtoToJSON = OrientationOpportunityMatchDtoToJSON;
exports.OrientationOpportunityMatchDtoToJSONTyped = OrientationOpportunityMatchDtoToJSONTyped;
const OrientationOpportunityRequestStatus_1 = require("./OrientationOpportunityRequestStatus");
const ShiftMatchProfileDto_1 = require("./ShiftMatchProfileDto");
/**
 * Check if a given object implements the OrientationOpportunityMatchDto interface.
 */
function instanceOfOrientationOpportunityMatchDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityMatchDtoFromJSON(json) {
    return OrientationOpportunityMatchDtoFromJSONTyped(json, false);
}
function OrientationOpportunityMatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoFromJSON)(json['nurseProfile']),
        'requestStatus': json['requestStatus'] == null ? undefined : (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusFromJSON)(json['requestStatus']),
        'message': json['message'] == null ? undefined : json['message'],
        'requestedAt': json['requestedAt'] == null ? undefined : (new Date(json['requestedAt'])),
        'statusUpdatedAt': json['statusUpdatedAt'] == null ? undefined : (new Date(json['statusUpdatedAt'])),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'notifiedAt': json['notifiedAt'] == null ? undefined : (new Date(json['notifiedAt'])),
    };
}
function OrientationOpportunityMatchDtoToJSON(json) {
    return OrientationOpportunityMatchDtoToJSONTyped(json, false);
}
function OrientationOpportunityMatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoToJSON)(value['nurseProfile']),
        'requestStatus': (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusToJSON)(value['requestStatus']),
        'message': value['message'],
        'requestedAt': value['requestedAt'] == null ? undefined : ((value['requestedAt']).toISOString()),
        'statusUpdatedAt': value['statusUpdatedAt'] == null ? undefined : ((value['statusUpdatedAt']).toISOString()),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'notifiedAt': value['notifiedAt'] == null ? undefined : ((value['notifiedAt']).toISOString()),
    };
}
//# sourceMappingURL=OrientationOpportunityMatchDto.js.map